import React from 'react';
import HeaderRlt2 from './HeaderRlt2';
import TestimonialCardRlt2 from './TestimonialCardRlt2';
import CTAButtonRlt1 from './CTAButtonRlt1';
import TimelineEventRlt2 from './TimelineEventRlt2';
import FeaturePointRlt2 from './FeaturePointRlt2';
import { BookOpenIcon, CalendarIcon, CheckCircleIcon } from 'lucide-react';
const AdvertorialRlt2 = () => {
  return <div className="max-w-4xl mx-auto bg-white shadow-md font-serif border border-gray-200" data-id="element-5415">
      <HeaderRlt2 data-id="element-5416" />
      <main className="px-4 sm:px-8 py-8" data-id="element-5417">
        <div className="prose max-w-none" data-id="element-5418">
          <div className="flex items-center text-xs text-gray-500 mb-8 border-b border-gray-200 pb-2" data-id="element-5419">
            <div className="flex items-center mr-4" data-id="element-5420">
              <BookOpenIcon className="h-3 w-3 mr-1" data-id="element-5421" />
              <span data-id="element-5422">Health Investigation Series</span>
            </div>
            <div className="flex items-center" data-id="element-5423">
              <CalendarIcon className="h-3 w-3 mr-1" data-id="element-5424" />
              <span data-id="element-5425">
                Updated:{' '}
                {(() => {
                const yesterday = new Date();
                yesterday.setDate(yesterday.getDate() - 1);
                return yesterday.toLocaleDateString('en-US', {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric'
                });
              })()}
              </span>
            </div>
          </div>

          <p className="mb-6 text-base leading-relaxed italic border-l-4 border-gray-400 pl-4 text-gray-700" data-id="element-5426">
            If you'd told me three years ago that shining red light on your
            stomach could drain fat cells, I would have dismissed it as wellness
            nonsense. Then I read the research. Then I tested 8 devices on 14
            volunteers for 12 weeks. What I discovered explains why most people
            fail—and why one device produced results that matched the clinical
            trials.
          </p>

          <div className="flex justify-center mb-6" data-id="element-5427"></div>

          <div className="flex justify-center mb-6" data-id="element-5428">
            <div className="w-full sm:w-2/3 bg-gray-50 p-5 rounded border border-gray-300 text-sm" data-id="element-5429">
              <div className="uppercase text-gray-600 text-xs font-sans tracking-wider mb-3 font-medium border-b border-gray-300 pb-2" data-id="element-5430">
                Who This Is For
              </div>
              <div className="space-y-3" data-id="element-5431">
                <div className="flex items-start" data-id="element-5432">
                  <CheckCircleIcon className="h-4 w-4 text-blue-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-5433" />
                  <span className="text-sm text-gray-700" data-id="element-5434">
                    Women in perimenopause or menopause dealing with stubborn
                    midsection fat
                  </span>
                </div>
                <div className="flex items-start" data-id="element-5435">
                  <CheckCircleIcon className="h-4 w-4 text-blue-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-5436" />
                  <span className="text-sm text-gray-700" data-id="element-5437">
                    Anyone on GLP-1 medications with pockets that won't respond
                  </span>
                </div>
                <div className="flex items-start" data-id="element-5438">
                  <CheckCircleIcon className="h-4 w-4 text-blue-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-5439" />
                  <span className="text-sm text-gray-700" data-id="element-5440">
                    People already doing everything right with one stubborn area
                  </span>
                </div>
                <div className="flex items-start" data-id="element-5441">
                  <CheckCircleIcon className="h-4 w-4 text-blue-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-5442" />
                  <span className="text-sm text-gray-700" data-id="element-5443">
                    Post-pregnancy women with persistent abdominal fat
                  </span>
                </div>
                <div className="flex items-start" data-id="element-5444">
                  <CheckCircleIcon className="h-4 w-4 text-blue-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-5445" />
                  <span className="text-sm text-gray-700" data-id="element-5446">
                    Men with love handles that won't respond to cutting
                  </span>
                </div>
                <div className="flex items-start" data-id="element-5447">
                  <CheckCircleIcon className="h-4 w-4 text-blue-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-5448" />
                  <span className="text-sm text-gray-700" data-id="element-5449">
                    Anyone who tried red light before and only got skin benefits
                  </span>
                </div>
              </div>
            </div>
          </div>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5450">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5451"></span>
            The Science I Couldn't Dismiss
          </h2>

          <p className="mb-5 text-base" data-id="element-5452">
            I spent twenty years telling clients that spot reduction was a myth.
            That fat loss was systemic. That you couldn't "target" stubborn
            areas with anything short of liposuction.
          </p>

          <p className="mb-5 text-base" data-id="element-5453">
            Then a colleague sent me a stack of peer-reviewed papers. I expected
            to debunk them in an afternoon.
          </p>

          <p className="mb-5 text-base" data-id="element-5454">Instead, I found:</p>

          <div className="space-y-4 mb-6" data-id="element-5455">
            <p className="mb-3 text-base bg-yellow-100 p-3 border-l-4 border-yellow-400" data-id="element-5456">
              <strong data-id="element-5457">Journal of Obesity Surgery:</strong> Double-blind,
              placebo-controlled trial. 3.27 inches lost across waist, hips, and
              thighs in two weeks. Placebo group: 0.35 inches. Statistical
              significance: p &lt; 0.001.
            </p>
            <p className="mb-3 text-base bg-yellow-100 p-3 border-l-4 border-yellow-400" data-id="element-5458">
              <strong data-id="element-5459">Lasers in Surgery and Medicine:</strong> Electron
              microscopy showing 80% of fat cell contents evacuated after just 6
              minutes of red light exposure. Researchers watched the cells
              deflate in real-time under the microscope.
            </p>
            <p className="mb-3 text-base bg-yellow-100 p-3 border-l-4 border-yellow-400" data-id="element-5460">
              <strong data-id="element-5461">Journal of Clinical and Aesthetic Dermatology:</strong>{' '}
              5.4 inches of combined circumference reduction at six weeks. Zero
              adverse events. Excellent safety profile.
            </p>
          </div>

          <p className="mb-5 text-base" data-id="element-5462">
            And in 2010, the FDA cleared this technology for "circumferential
            reduction of waist, hips, and thighs." Not for general wellness or
            for skin health. For measurable fat reduction.
          </p>

          <p className="mb-5 text-base" data-id="element-5463">
            I sat with these papers for a week. The mechanism was elegant. The
            results were reproducible across multiple trials. This wasn't
            wellness marketing—this was documented physics.
          </p>

          <p className="mb-6 text-base" data-id="element-5464">
            So I needed to understand: how does shining a light actually empty a
            fat cell?
          </p>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5465">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5466"></span>
            How Red Light Actually Drains Fat
          </h2>

          <div className="flex justify-center mb-8" data-id="element-5467">
            <img src="https://cdn.magicpatterns.com/uploads/94QarDWvbki4GiuN3uHoSY/LNgNIr1pKH59ptOZpPCi1.png" alt="Diagram showing fat cell deflation process - temporary pores release triglycerides into interstitial space, which are picked up by lymphatic vessels for energy oxidation" className="w-full max-w-2xl rounded border border-gray-300" data-id="element-5468" />
          </div>

          <p className="mb-5 text-base" data-id="element-5469">
            Think of your fat cell like a water balloon. The red light at 660nm
            wavelength essentially pokes tiny holes in it. The
            contents—triglycerides, fatty acids, glycerol—leak out through these
            pores.
          </p>

          <p className="mb-5 text-base" data-id="element-5470">
            The cell doesn't die. It deflates. Like a grape becoming a raisin.
          </p>

          <p className="mb-5 text-base italic text-blue-900 bg-blue-50 border-l-4 border-blue-500 pl-4 py-3" data-id="element-5471">
            Now here's the important part: the fat doesn't disappear from your
            body immediately. It leaks into your interstitial fluid, gets picked
            up by your lymphatic system, and enters your bloodstream.
          </p>

          <p className="mb-5 text-base" data-id="element-5472">
            From there, your body can burn it as energy—when you're moving.
          </p>

          <p className="mb-5 text-base" data-id="element-5473">
            This is why red light therapy requires movement afterward. The light
            unlocks the fat. Your activity burns it.
          </p>

          <p className="mb-6 text-base" data-id="element-5474">
            Reading this research changed my assumptions. The mechanism was
            elegant. The physics were sound. The clinical results were
            reproducible.
          </p>

          <p className="mb-5 text-base" data-id="element-5475">
            So I started recommending red light therapy to clients with stubborn
            fat.
          </p>

          <p className="mb-6 text-base" data-id="element-5476">And that's when the confusion began.</p>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5477">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5478"></span>
            The Gap Between Research and Reality
          </h2>

          <div className="flex justify-center mb-8" data-id="element-5479">
            <img src="https://cdn.magicpatterns.com/uploads/6ggWu49BBf5fW7TQq7yHWL/JnLOkUasoxzuzYRTXpOo6.png" alt="Medical professional consulting with patient using red light therapy device" className="w-full max-w-2xl rounded border border-gray-300" data-id="element-5480" />
          </div>

          <p className="mb-5 text-base" data-id="element-5481">
            Over the past two years, I've recommended red light therapy to
            dozens of clients.
          </p>

          <p className="mb-5 text-base" data-id="element-5482">
            The clinical research promised 3-5 inches of reduction.
          </p>

          <p className="mb-5 text-base" data-id="element-5483">
            My clients were seeing maybe half an inch. Sometimes an inch. A
            fraction of what the studies showed.
          </p>

          <p className="mb-5 text-base" data-id="element-5484">
            They reported other benefits—tighter skin, smoother texture, reduced
            inflammation. The devices were doing something. But the dramatic fat
            reduction from the clinical trials wasn't really happening.
          </p>

          <p className="mb-5 text-base" data-id="element-5485">
            Online communities told the same story— people using devices for
            months, getting skin benefits, but no fat loss. Satisfaction rate
            for fat loss specifically: around 20-25%.
          </p>

          <p className="mb-5 text-base" data-id="element-5486">
            The mechanism was real, the studies were legitimate, and the FDA
            clearance was based on actual clinical outcomes - it was definitely
            not one of the internet gimmicks we see all the time.
          </p>

          <p className="mb-5 text-base" data-id="element-5487">
            So what would it actually take to see the results the research
            promised?
          </p>

          <p className="mb-5 text-base" data-id="element-5488">
            Something in the chain was broken. I decided to find out what.
          </p>

          <p className="mb-6 text-base italic text-blue-900 bg-blue-50 border-l-4 border-blue-500 pl-4 py-3" data-id="element-5489">
            What I later found explained why most devices fail—and the only way
            to actually drain stubborn fat from targeted areas. Something that
            wasn't possible without a surgery just 20 years ago.
          </p>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5490">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5491"></span>
            The Investigation: 8 Devices, 14 Volunteers, 12 Weeks
          </h2>

          <div className="flex justify-center mb-8" data-id="element-5492">
            <img src="https://cdn.magicpatterns.com/uploads/31NywSxade2JCjwYchvFWq/ztdKjRAdxq3qizduNv4qV.png" alt="Eight red light therapy devices tested - product boxes arranged on porch" className="w-full max-w-2xl rounded border border-gray-300" data-id="element-5493" />
          </div>

          <p className="mb-5 text-base" data-id="element-5494">
            I purchased eight red light therapy devices marketed specifically
            for fat loss and recruited 14 volunteers for a controlled 12-week
            study.
          </p>

          <h3 className="text-xl font-serif font-bold text-gray-800 mt-8 mb-4" data-id="element-5495">
            The Volunteers
          </h3>

          <div className="space-y-3 mb-6 bg-gray-50 p-5 rounded border border-gray-300" data-id="element-5496">
            <div className="bg-white p-5 rounded-lg border-2 border-blue-100 shadow-sm" data-id="element-5497">
              <div className="flex items-start gap-3" data-id="element-5498">
                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-5499">
                  <span className="text-blue-700 font-bold text-sm" data-id="element-5500">M</span>
                </div>
                <div className="flex-1" data-id="element-5501">
                  <div className="flex items-center gap-2 mb-1" data-id="element-5502">
                    <strong className="text-base" data-id="element-5503">Maria, 54</strong>
                    <CheckCircleIcon className="h-4 w-4 text-blue-600" data-id="element-5504" />
                    <span className="text-xs text-blue-600 font-medium" data-id="element-5505">
                      Verified Participant
                    </span>
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-5506">
                    On Mounjaro for 10 months. Lost 47 pounds but her lower
                    belly hadn't budged in the last four months despite
                    continued medication and consistent walking.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-5 rounded-lg border-2 border-blue-100 shadow-sm" data-id="element-5507">
              <div className="flex items-start gap-3" data-id="element-5508">
                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-5509">
                  <span className="text-blue-700 font-bold text-sm" data-id="element-5510">J</span>
                </div>
                <div className="flex-1" data-id="element-5511">
                  <div className="flex items-center gap-2 mb-1" data-id="element-5512">
                    <strong className="text-base" data-id="element-5513">Jennifer, 49</strong>
                    <CheckCircleIcon className="h-4 w-4 text-blue-600" data-id="element-5514" />
                    <span className="text-xs text-blue-600 font-medium" data-id="element-5515">
                      Verified Participant
                    </span>
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-5516">
                    Perimenopausal. Gained 15 pounds around her midsection over
                    two years despite no change in diet or exercise. Classic
                    hormonal redistribution. Her doctor called it "menopause
                    belly."
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-5 rounded-lg border-2 border-blue-100 shadow-sm" data-id="element-5517">
              <div className="flex items-start gap-3" data-id="element-5518">
                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-5519">
                  <span className="text-blue-700 font-bold text-sm" data-id="element-5520">D</span>
                </div>
                <div className="flex-1" data-id="element-5521">
                  <div className="flex items-center gap-2 mb-1" data-id="element-5522">
                    <strong className="text-base" data-id="element-5523">David, 58</strong>
                    <CheckCircleIcon className="h-4 w-4 text-blue-600" data-id="element-5524" />
                    <span className="text-xs text-blue-600 font-medium" data-id="element-5525">
                      Verified Participant
                    </span>
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-5526">
                    Avid cyclist, 200 miles per week. Measured at 18% body fat
                    but persistent love handles that wouldn't respond to caloric
                    deficits or increased cardio.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-5 rounded-lg border-2 border-blue-100 shadow-sm" data-id="element-5527">
              <div className="flex items-start gap-3" data-id="element-5528">
                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-5529">
                  <span className="text-blue-700 font-bold text-sm" data-id="element-5530">R</span>
                </div>
                <div className="flex-1" data-id="element-5531">
                  <div className="flex items-center gap-2 mb-1" data-id="element-5532">
                    <strong className="text-base" data-id="element-5533">Rachel, 38</strong>
                    <CheckCircleIcon className="h-4 w-4 text-blue-600" data-id="element-5534" />
                    <span className="text-xs text-blue-600 font-medium" data-id="element-5535">
                      Verified Participant
                    </span>
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-5536">
                    18 months postpartum. Back to pre-pregnancy weight but
                    stubborn lower abdominal fat remained. "I've tried
                    everything," she told me. "This pouch won't leave."
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-5 rounded-lg border-2 border-blue-100 shadow-sm" data-id="element-5537">
              <div className="flex items-start gap-3" data-id="element-5538">
                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-5539">
                  <span className="text-blue-700 font-bold text-sm" data-id="element-5540">T</span>
                </div>
                <div className="flex-1" data-id="element-5541">
                  <div className="flex items-center gap-2 mb-1" data-id="element-5542">
                    <strong className="text-base" data-id="element-5543">Tom, 44</strong>
                    <CheckCircleIcon className="h-4 w-4 text-blue-600" data-id="element-5544" />
                    <span className="text-xs text-blue-600 font-medium" data-id="element-5545">
                      Verified Participant
                    </span>
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-5546">
                    Lost 60 pounds over two years through diet and exercise.
                    Left with stubborn flank fat and loose skin. Had tried two
                    other red light devices with minimal results.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-5 rounded-lg border-2 border-blue-100 shadow-sm" data-id="element-5547">
              <div className="flex items-start gap-3" data-id="element-5548">
                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-5549">
                  <span className="text-blue-700 font-bold text-sm" data-id="element-5550">L</span>
                </div>
                <div className="flex-1" data-id="element-5551">
                  <div className="flex items-center gap-2 mb-1" data-id="element-5552">
                    <strong className="text-base" data-id="element-5553">Linda, 61</strong>
                    <CheckCircleIcon className="h-4 w-4 text-blue-600" data-id="element-5554" />
                    <span className="text-xs text-blue-600 font-medium" data-id="element-5555">
                      Verified Participant
                    </span>
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-5556">
                    Post-menopausal for six years. Frustrated that her body
                    "stopped listening" to the same routine that kept her lean
                    for decades. Midsection thickening despite no lifestyle
                    changes.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <p className="mb-6 text-base" data-id="element-5557">
            Plus six additional volunteers—men and women aged 38-67, each with
            documented stubborn fat deposits that had resisted conventional
            approaches.
          </p>

          <h3 className="text-xl font-serif font-bold text-gray-800 mt-8 mb-4" data-id="element-5558">
            The Devices
          </h3>

          <div className="overflow-x-auto mb-6" data-id="element-5559">
            <table className="min-w-full border border-gray-300 text-sm" data-id="element-5560">
              <thead className="bg-gray-100" data-id="element-5561">
                <tr data-id="element-5562">
                  <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5563">
                    Device
                  </th>
                  <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5564">
                    Wavelength
                  </th>
                  <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5565">
                    LED Count
                  </th>
                  <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5566">
                    Power
                  </th>
                  <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5567">
                    Price
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-5568">
                <tr data-id="element-5569">
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5570">
                    NuShape Lipo Wrap
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5571">
                    660nm / 850nm
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5572">120</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5573">60W</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5574">$149</td>
                </tr>
                <tr data-id="element-5575">
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5576">
                    MitoRed Belt Pro
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5577">
                    660nm / 850nm
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5578">144</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5579">72W</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5580">$289</td>
                </tr>
                <tr data-id="element-5581">
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5582">
                    Bestqool Body Wrap
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5583">
                    660nm / 850nm
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5584">105</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5585">50W</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5586">$89</td>
                </tr>
                <tr data-id="element-5587">
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5588">
                    InfraGlow Contour Belt
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5589">
                    660nm / 850nm
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5590">132</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5591">65W</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5592">$199</td>
                </tr>
                <tr data-id="element-5593">
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5594">
                    RedRush 360
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5595">
                    660nm / 850nm
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5596">120</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5597">60W</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5598">$129</td>
                </tr>
                <tr data-id="element-5599">
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5600">
                    TheraBelt Plus
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5601">
                    660nm / 850nm
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5602">108</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5603">55W</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5604">$169</td>
                </tr>
                <tr data-id="element-5605">
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5606">
                    LumoWrap Basic
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5607">
                    660nm / 850nm
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5608">90</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5609">45W</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5610">$59</td>
                </tr>
                <tr className="border border-gray-300 px-3 py-2" data-id="element-5611">
                  <td className="border border-gray-300 px-3 py-2 font-medium" data-id="element-5612">
                    Glokore Deep Red Light Wrap
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5613">
                    660nm / 850nm
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5614">120</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5615">60W</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5616">$179</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p className="mb-5 text-base" data-id="element-5617">Look at these specifications.</p>

          <p className="mb-6 text-base italic text-blue-900 bg-blue-50 border-l-4 border-blue-500 pl-4 py-3" data-id="element-5618">
            Same wavelengths across the board—the 660nm red and 850nm infrared
            that research validated. Similar LED counts. Comparable power
            outputs. Price ranging from budget to premium.
          </p>

          <p className="mb-6 text-base" data-id="element-5619">
            If specifications told the whole story, results should be roughly
            similar.
          </p>

          <h3 className="text-xl font-serif font-bold text-gray-800 mt-8 mb-4" data-id="element-5620">
            The Protocol
          </h3>

          <div className="border border-gray-300 p-5 my-6 bg-gray-50 rounded" data-id="element-5621">
            <ul className="space-y-2 text-base" data-id="element-5622">
              <li data-id="element-5623">• 20 minutes per session, 5 days per week</li>
              <li data-id="element-5624">
                • Device applied directly to stubborn area (skin contact
                required)
              </li>
              <li data-id="element-5625">• Followed immediately by 30 minutes of moderate walking</li>
              <li data-id="element-5626">• 8+ glasses of water daily</li>
              <li data-id="element-5627">• No dietary changes required (we weren't testing diet)</li>
              <li data-id="element-5628">• Weekly measurements, monthly photos</li>
            </ul>
          </div>

          <p className="mb-6 text-base italic text-blue-900 bg-blue-50 border-l-4 border-blue-500 pl-4 py-3" data-id="element-5629">
            According to the clinical research, every single one of these
            volunteers should see 3-5 inches of reduction within weeks. The
            stubborn fat that resisted everything else should finally start
            draining.
          </p>

          <div className="mt-12 mb-10" data-id="element-5630">
            <h2 className="text-2xl font-serif font-bold text-gray-800 mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-5631">
              <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5632"></span>
              Week 1-2: Everything Works
            </h2>

            <p className="mb-5 text-base" data-id="element-5633">
              The first two weeks looked promising across the board.
            </p>

            <p className="mb-5 text-base" data-id="element-5634">
              Every device showed some reduction. Small—0.2 to 0.5 inches—but
              measurable movement. Volunteers reported their skin feeling
              tighter, looking smoother. Some noticed reduced bloating.
            </p>

            <div className="overflow-x-auto mb-6" data-id="element-5635">
              <table className="min-w-full border border-gray-300 text-sm" data-id="element-5636">
                <thead className="bg-gray-100" data-id="element-5637">
                  <tr data-id="element-5638">
                    <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5639">
                      Device
                    </th>
                    <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5640">
                      Week 2 Waist
                    </th>
                    <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5641">
                      Week 2 Thigh
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-5642">
                  <tr data-id="element-5643">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5644">
                      NuShape Lipo Wrap
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5645">
                      -0.3"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5646">
                      -0.2"
                    </td>
                  </tr>
                  <tr data-id="element-5647">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5648">
                      MitoRed Belt Pro
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5649">
                      -0.4"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5650">
                      -0.3"
                    </td>
                  </tr>
                  <tr data-id="element-5651">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5652">
                      Bestqool Body Wrap
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5653">
                      -0.2"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5654">
                      -0.1"
                    </td>
                  </tr>
                  <tr data-id="element-5655">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5656">
                      InfraGlow Contour Belt
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5657">
                      -0.3"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5658">
                      -0.2"
                    </td>
                  </tr>
                  <tr data-id="element-5659">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5660">
                      RedRush 360
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5661">
                      -0.3"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5662">
                      -0.2"
                    </td>
                  </tr>
                  <tr data-id="element-5663">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5664">
                      TheraBelt Plus
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5665">
                      -0.3"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5666">
                      -0.2"
                    </td>
                  </tr>
                  <tr data-id="element-5667">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5668">
                      LumoWrap Basic
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5669">
                      -0.2"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5670">
                      -0.1"
                    </td>
                  </tr>
                  <tr data-id="element-5671">
                    <td className="border border-gray-300 px-3 py-2 font-medium" data-id="element-5672">
                      Glokore Deep RLT
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5673">
                      -0.4"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5674">
                      -0.3"
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p className="mb-5 text-base" data-id="element-5675">
              Small numbers, but movement across the board. At this point, there
              was no clear winner.
            </p>

            <p className="mb-6 text-base italic" data-id="element-5676">
              "Maybe they all work," I wrote in my notes. "Maybe the price
              differences are just marketing."
            </p>

            <p className="mb-6 text-base" data-id="element-5677">I was wrong.</p>
          </div>

          <div className="mt-12 mb-10" data-id="element-5678">
            <h2 className="text-2xl font-serif font-bold text-gray-800 mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-5679">
              <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5680"></span>
              Week 4-6: The Split
            </h2>

            <p className="mb-5 text-base" data-id="element-5681">
              By week six, the pattern had fractured.
            </p>

            <p className="mb-5 text-base" data-id="element-5682">
              Seven devices had plateaued completely. Measurements stopped
              improving. Some volunteers actually saw slight increases as
              initial water weight fluctuations normalized.
            </p>

            <div className="overflow-x-auto mb-6" data-id="element-5683">
              <table className="min-w-full border border-gray-300 text-sm" data-id="element-5684">
                <thead className="bg-gray-100" data-id="element-5685">
                  <tr data-id="element-5686">
                    <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5687">
                      Device
                    </th>
                    <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5688">
                      Week 6 Waist
                    </th>
                    <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5689">
                      Week 6 Thigh
                    </th>
                    <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5690">
                      Trend
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-5691">
                  <tr data-id="element-5692">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5693">
                      NuShape Lipo Wrap
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-yellow-600 font-medium" data-id="element-5694">
                      -0.8"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-yellow-600 font-medium" data-id="element-5695">
                      -0.3"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-yellow-600 font-medium" data-id="element-5696">
                      Slowing
                    </td>
                  </tr>
                  <tr data-id="element-5697">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5698">
                      MitoRed Belt Pro
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-yellow-600 font-medium" data-id="element-5699">
                      -0.7"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-yellow-600 font-medium" data-id="element-5700">
                      -0.4"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-yellow-600 font-medium" data-id="element-5701">
                      Slowing
                    </td>
                  </tr>
                  <tr data-id="element-5702">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5703">
                      Bestqool Body Wrap
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5704">
                      -0.3"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5705">
                      -0.2"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5706">
                      Stopped
                    </td>
                  </tr>
                  <tr data-id="element-5707">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5708">
                      InfraGlow Contour Belt
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5709">
                      -0.4"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5710">
                      -0.3"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5711">
                      Stopped
                    </td>
                  </tr>
                  <tr data-id="element-5712">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5713">
                      RedRush 360
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5714">
                      -0.5"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5715">
                      -0.3"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5716">
                      Stopped
                    </td>
                  </tr>
                  <tr data-id="element-5717">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5718">
                      TheraBelt Plus
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5719">
                      -0.4"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5720">
                      -0.3"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5721">
                      Stopped
                    </td>
                  </tr>
                  <tr data-id="element-5722">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5723">
                      LumoWrap Basic
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5724">
                      -0.3"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5725">
                      -0.2"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5726">
                      Stopped
                    </td>
                  </tr>
                  <tr data-id="element-5727">
                    <td className="border border-gray-300 px-3 py-2 font-medium" data-id="element-5728">
                      Glokore Deep RLT
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5729">
                      -1.2"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5730">
                      -0.7"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5731">
                      Continuing
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="mt-12 mb-10" data-id="element-5732">
            <h2 className="text-2xl font-serif font-bold text-gray-800 mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-5733">
              <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5734"></span>
              Week 8-10: The Separation Widens
            </h2>

            <div className="flex justify-center mb-8" data-id="element-5735">
              <img src="https://cdn.magicpatterns.com/uploads/weoEoLHvJyz4DGeD9N3kv8/v_7tH-HZydCx26l54zzk_.png" alt="Red light therapy devices and research materials on desk" className="w-full max-w-2xl rounded border border-gray-300" data-id="element-5736" />
            </div>

            <p className="mb-5 text-base" data-id="element-5737">
              By week ten, the gap was undeniable.
            </p>

            <p className="mb-5 text-base italic border-l-4 border-red-500 pl-4 text-gray-700" data-id="element-5738">
              Seven devices had delivered their full results by week 4. Nothing
              further. Volunteers using them had seen somewhere between 0.4 and
              0.9 inches of total reduction—roughly 10-25% of what the clinical
              studies promised.
            </p>

            <p className="mb-5 text-base" data-id="element-5739">
              Only one device was still delivering the measurable results.
            </p>

            <p className="mb-5 text-base" data-id="element-5740">
              Linda, 61, had been skeptical from the start, but by week ten, she
              was down 2.1 inches on her waist. "I keep checking the measuring
              tape because I don't believe it."
            </p>

            <div className="bg-white p-6 rounded-lg border-2 border-blue-100 shadow-sm mb-6" data-id="element-5741">
              <div className="flex items-start gap-3 mb-3" data-id="element-5742">
                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-5743">
                  <span className="text-blue-700 font-bold text-sm" data-id="element-5744">L</span>
                </div>
                <div className="flex-1" data-id="element-5745">
                  <div className="flex items-center gap-2 mb-1" data-id="element-5746">
                    <strong className="text-base" data-id="element-5747">Linda, 61</strong>
                    <CheckCircleIcon className="h-4 w-4 text-blue-600" data-id="element-5748" />
                    <span className="text-xs text-blue-600 font-medium" data-id="element-5749">
                      Verified Participant
                    </span>
                  </div>
                  <div className="text-xs text-gray-500 font-medium" data-id="element-5750">
                    Week 10
                  </div>
                </div>
              </div>
              <p className="text-sm text-gray-700 italic border-l-4 border-blue-500 pl-4" data-id="element-5751">
                "At my age, I figured menopause had won...In 10 weeks with Dr.
                Sarah Mitchell I saw my waist reduced by 2.1 inches... And all I
                had to do was use the red light therapy wrap, walk and drink
                water. I keep checking the measure tape because I can't believe
                it! This is just awesome."
              </p>
            </div>
          </div>

          <div className="mt-12 mb-10" data-id="element-5752">
            <h2 className="text-2xl font-serif font-bold text-gray-800 mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-5753">
              <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5754"></span>
              Week 12: Final Results
            </h2>

            <div className="overflow-x-auto mb-6" data-id="element-5755">
              <table className="min-w-full border border-gray-300 text-sm" data-id="element-5756">
                <thead className="bg-gray-100" data-id="element-5757">
                  <tr data-id="element-5758">
                    <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5759">
                      Device
                    </th>
                    <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5760">
                      Avg. Waist Reduction
                    </th>
                    <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5761">
                      Avg. Thigh Reduction
                    </th>
                    <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5762">
                      Still Improving at Week 12?
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-5763">
                  <tr data-id="element-5764">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5765">
                      NuShape Lipo Wrap
                    </td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5766">0.8"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5767">0.4"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5768">
                      No (plateaued week 6)
                    </td>
                  </tr>
                  <tr data-id="element-5769">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5770">
                      MitoRed Belt Pro
                    </td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5771">0.9"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5772">0.5"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5773">
                      No (plateaued week 7)
                    </td>
                  </tr>
                  <tr data-id="element-5774">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5775">
                      Bestqool Body Wrap
                    </td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5776">0.4"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5777">0.2"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5778">
                      No (plateaued week 3)
                    </td>
                  </tr>
                  <tr data-id="element-5779">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5780">
                      InfraGlow Contour Belt
                    </td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5781">0.5"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5782">0.3"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5783">
                      No (plateaued week 4)
                    </td>
                  </tr>
                  <tr data-id="element-5784">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5785">
                      RedRush 360
                    </td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5786">0.6"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5787">0.4"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5788">
                      No (plateaued week 4)
                    </td>
                  </tr>
                  <tr data-id="element-5789">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5790">
                      TheraBelt Plus
                    </td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5791">0.5"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5792">0.3"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5793">
                      No (plateaued week 4)
                    </td>
                  </tr>
                  <tr data-id="element-5794">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5795">
                      LumoWrap Basic
                    </td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5796">0.3"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5797">0.2"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5798">
                      No (plateaued week 3)
                    </td>
                  </tr>
                  <tr className="bg-green-50" data-id="element-5799">
                    <td className="border border-gray-300 px-3 py-2 font-medium" data-id="element-5800">
                      Glokore Deep Red Light Wrap
                    </td>
                    <td className="border border-gray-300 px-3 py-2 font-medium" data-id="element-5801">
                      2.7"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 font-medium" data-id="element-5802">
                      1.6"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 font-medium" data-id="element-5803">
                      Yes
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p className="mb-5 text-base" data-id="element-5804">
              Same wavelengths. Same LED counts. Same protocols. Same volunteer
              demographics.
            </p>

            <p className="mb-5 text-base" data-id="element-5805">Completely different outcomes.</p>

            <p className="mb-5 text-base" data-id="element-5806">
              The Glokore device produced 3-4x the results of everything else
              tested. And it was still working at week 12 when everything else
              had stalled months earlier.
            </p>

            <div className="bg-white p-6 rounded-lg border-2 border-blue-100 shadow-sm mb-6" data-id="element-5807">
              <div className="flex items-start gap-3 mb-3" data-id="element-5808">
                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-5809">
                  <span className="text-blue-700 font-bold text-sm" data-id="element-5810">S</span>
                </div>
                <div className="flex-1" data-id="element-5811">
                  <div className="flex items-center gap-2 mb-1" data-id="element-5812">
                    <strong className="text-base" data-id="element-5813">Susan, 47</strong>
                    <CheckCircleIcon className="h-4 w-4 text-blue-600" data-id="element-5814" />
                    <span className="text-xs text-blue-600 font-medium" data-id="element-5815">
                      Verified Participant
                    </span>
                  </div>
                  <div className="text-xs text-gray-600 font-medium mb-2" data-id="element-5816">
                    On Wegovy for 8 months, lost 55 pounds:
                  </div>
                </div>
              </div>
              <p className="text-sm text-gray-700 italic border-l-4 border-blue-500 pl-4" data-id="element-5817">
                "My waist wouldn't budge no matter what. The medication did
                everything except touch that one area. But now—2.4 inches gone
                in 12 weeks—more than the last four months of Wegovy combined."
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg border-2 border-blue-100 shadow-sm mb-6" data-id="element-5818">
              <div className="flex items-start gap-3 mb-3" data-id="element-5819">
                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-5820">
                  <span className="text-blue-700 font-bold text-sm" data-id="element-5821">R</span>
                </div>
                <div className="flex-1" data-id="element-5822">
                  <div className="flex items-center gap-2 mb-1" data-id="element-5823">
                    <strong className="text-base" data-id="element-5824">Rachel, 38</strong>
                    <CheckCircleIcon className="h-4 w-4 text-blue-600" data-id="element-5825" />
                    <span className="text-xs text-blue-600 font-medium" data-id="element-5826">
                      Verified Participant
                    </span>
                  </div>
                  <div className="text-xs text-gray-600 font-medium mb-2" data-id="element-5827">
                    18 months postpartum:
                  </div>
                </div>
              </div>
              <p className="text-sm text-gray-700 italic border-l-4 border-blue-500 pl-4" data-id="element-5828">
                "I cried when I measured week 10. I've been fighting this pouch
                since my son was born. Eighteen months of hating what I saw in
                the mirror. I thought it was permanent. This investigation
                really helped, I'll stick to red light therapy now."
              </p>
            </div>

            <p className="mb-6 text-base" data-id="element-5829">
              I needed to understand why this one device worked when seven
              others—with nearly identical specifications—had failed.
            </p>
          </div>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5830">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5831"></span>
            Tracking Down the Mystery
          </h2>

          <p className="mb-5 text-base" data-id="element-5832">
            Glokore was a company I'd never heard of.
          </p>

          <p className="mb-5 text-base" data-id="element-5833">Small operation out of Kentucky.</p>

          <p className="mb-5 text-base" data-id="element-5834">Basic website, no flashy marketing.</p>

          <p className="mb-5 text-base" data-id="element-5835">
            Yet their device outperformed everything else in my study by 3-4x.
          </p>

          <div className="flex justify-center mb-8" data-id="element-5836">
            <img src="https://cdn.magicpatterns.com/uploads/oMyAjnUEAxXSsezjHjcbJ4/pasted-image.png" alt="Email from Dr. Sarah Mitchell to Rob Hartley about red light therapy device investigation" className="w-full max-w-2xl rounded border border-gray-300" data-id="element-5837" />
          </div>

          <p className="mb-5 text-base" data-id="element-5838">
            I found the founder's email and reached out.
          </p>

          <p className="mb-6 text-base" data-id="element-5839">The next morning, my phone rang.</p>

          <p className="mb-6 text-base leading-relaxed italic border-l-4 border-gray-400 pl-4 text-gray-700" data-id="element-5840">
            "Dr. Mitchell? This is Rob Hartley. I've been wondering when someone
            would actually test these devices properly."
          </p>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5841">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5842"></span>
            The Oceaneering Engineer Who Fixed Red Light Therapy
          </h2>
          <div className="flex justify-center mb-8" data-id="element-5843">
            <img src="https://cdn.magicpatterns.com/uploads/gFCtxBWZ6AqXKvFktbuQnL/0sYaq6YkSHENC7FSYjD19.png" alt="Rob Hartley, retired optical engineer from Oceaneering International, in his office" className="w-full max-w-2xl rounded border border-gray-300" data-id="element-5844" />
          </div>
          <p className="mb-5 text-base" data-id="element-5845">
            Rob wasn't what I expected. A retired optical engineer who spent 32
            years at Oceaneering International—the company that builds
            illumination systems for deep-sea submersibles. He'd designed lights
            that explored the Titanic. The Mariana Trench. Equipment where
            failure meant losing million-dollar missions.
          </p>

          <p className="mb-6 text-base leading-relaxed italic border-l-4 border-gray-400 pl-4 text-gray-700" data-id="element-5846">
            "My wife Karen is why this exists," he started. "She tried every red
            light device on the market. Her skin looked great. But the stubborn
            fat? Nothing. Months of use. Nothing."
          </p>

          <p className="mb-5 text-base" data-id="element-5847">
            "That's exactly what my volunteers experienced," I said.
          </p>

          <p className="mb-3 text-base bg-yellow-100 p-3 border-l-4 border-yellow-400" data-id="element-5848">
            "Right. So I did what engineers do—I took the devices apart."
          </p>

          <p className="mb-5 text-base" data-id="element-5849">What he found explained everything.</p>

          <p className="mb-5 text-base" data-id="element-5850">
            "Bare LEDs. Exposed diodes soldered onto a flexible strip. Light
            spraying in every direction—forward, sideways, even backward into
            the housing."
          </p>

          <div className="flex justify-center mb-8" data-id="element-5851">
            <img src="https://cdn.magicpatterns.com/uploads/c9fo2NbifB1Yzomx5ULCAW/KrEphB53It6oUW-2OWBRE.png" alt="Thermal imaging showing bare LED light scattering at surface - energy trapped at surface while fat layer remains cold and untouched by light" className="w-full max-w-2xl rounded border border-gray-300" data-id="element-5852" />
          </div>

          <p className="mb-5 text-base" data-id="element-5853">
            "Most of these devices were built for skin. Tightening. Healing.
            Collagen. That's what red light does at the surface, and that's what
            they were designed for."
          </p>

          <p className="mb-5 text-base" data-id="element-5854">
            "Then the fat-loss research came out. Manufacturers saw a new
            market. Suddenly every skin belt was being advertised for 'fat
            reduction.' Same device. New marketing. But they didn't change
            anything about the engineering."
          </p>

          <p className="mb-5 text-base" data-id="element-5855">
            "They're selling skin devices for a fat problem."
          </p>

          <p className="mb-3 text-base bg-yellow-100 p-3 border-l-4 border-yellow-400" data-id="element-5856">
            "Your fat cells aren't on the surface. They're four to eight
            millimeters deep. For red light to drain them, it has to actually
            REACH them. These devices scatter light across the skin. Great for
            collagen. But it disperses before reaching the fat layer."
          </p>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5857">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5858"></span>
            The Deep-Sea Solution
          </h2>

          <div className="flex justify-center mb-8" data-id="element-5859">
            <img src="https://cdn.magicpatterns.com/uploads/fi1rDxyr8r4fF8X1CPLSFd/curtin_university_sydney_expedition.webp" alt="Deep-sea submersible with precision lighting system exploring underwater wreckage" className="w-full max-w-2xl rounded border border-gray-300" data-id="element-5860" />
          </div>

          <p className="mb-5 text-base" data-id="element-5861">"So how did you fix it?" I asked.</p>

          <p className="mb-5 text-base" data-id="element-5862">
            "At the bottom of the ocean, scattered light is useless. Creates
            backscatter—a blinding white haze. You can't photograph the Titanic
            if your lights are spraying everywhere."
          </p>

          <p className="mb-3 text-base bg-yellow-100 p-3 border-l-4 border-yellow-400" data-id="element-5863">
            "So what do we do? Reflector housings. Every light sits inside a
            precision-machined reflector that catches any photon trying to
            escape sideways and redirects it forward. Specific beam angles.
            Every photon travels where it needs to go, or the mission fails."
          </p>

          <p className="mb-5 text-base" data-id="element-5864">"Same principle here."</p>

          <p className="mb-5 text-base" data-id="element-5865">
            "Think of a garden hose. Wide spray—water goes everywhere but no
            pressure. No penetration. That's what standard devices do."
          </p>

          <div className="flex justify-center mb-8" data-id="element-5866">
            <img src="https://cdn.magicpatterns.com/uploads/i2EZAKSCiq86cMHcfyrspk/RN8avCG-fTj-fZDLrCZYN.png" alt="Thermal imaging comparison showing reflector-backed deep LED penetrating energy through surface into warm fat layer being deflated by light" className="w-full max-w-2xl rounded border border-gray-300" data-id="element-5867" />
          </div>

          <p className="mb-5 text-base" data-id="element-5868">
            "Turn it to jet. Same water, but it PUNCHES. It penetrates."
          </p>

          <p className="mb-5 text-base" data-id="element-5869">
            "That's why your volunteers kept losing inches when everyone else
            plateaued. My light isn't scattering at the surface. It's punching
            through to the fat layer. Every session, it's actually reaching the
            cells. Every session, it's draining them. Week after week."
          </p>

          <p className="mb-6 text-base" data-id="element-5870">
            "That's what I built for Karen. And that's why it works."
          </p>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5871">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5872"></span>
            The $488,719 Investment
          </h2>

          <p className="mb-5 text-base" data-id="element-5873">
            "This sounds expensive to manufacture," I said.
          </p>

          <p className="mb-5 text-base" data-id="element-5874">
            "Three of us from Oceaneering pooled our 401Ks. About half a million
            dollars. Precision molding equipment to produce reflector housings
            at the tolerances we needed. You can't order these from a
            supplier—nobody makes them."
          </p>

          <div className="flex justify-center mb-8" data-id="element-5875">
            <img src="https://cdn.magicpatterns.com/uploads/2WtZ6Jz8grSFbxkog1zBSF/YKe82QRXFzp6UlytzkQbn.png" alt="Precision injection molding equipment manufacturing LED reflector housings with robotic arm and quality control display" className="w-full max-w-2xl rounded border border-gray-300" data-id="element-5876" />
          </div>

          <p className="mb-5 text-base" data-id="element-5877">"Your wife must have loved that."</p>

          <p className="mb-6 text-base" data-id="element-5878">
            "She said if it didn't work, I was sleeping in the garage for the
            rest of my life." He paused. "It worked."
          </p>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5879">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5880"></span>
            The Proof
          </h2>

          <div className="flex justify-center mb-8" data-id="element-5881">
            <img src="https://cdn.magicpatterns.com/uploads/9pGL49nw5juDn56U9egbr5/gcanCRJjpCeAwLF40yXo2.png" alt="Robert Hartley on Zoom call demonstrating the Deep Red Light Therapy Wrap with reflector-backed LEDs in his home office" className="w-full max-w-2xl rounded border border-gray-300" data-id="element-5882" />
          </div>

          <p className="mb-5 text-base" data-id="element-5883">
            "When Karen used the prototype, she saw what the clinical studies
            promised," Rob said. "1.9 inches off her waist in the first month.
            Still going at month two. The stubborn fat that hadn't moved in
            years—finally moving."
          </p>

          <p className="mb-5 text-base" data-id="element-5884">
            "That's exactly what I saw with my volunteers," I told him.
            "Everyone using your device kept losing. Everyone else plateaued by
            week four."
          </p>

          <p className="mb-5 text-base" data-id="element-5885">
            "If it doesn't actually work, what's the point?" he said.
          </p>

          <p className="mb-5 text-base" data-id="element-5886">
            "How are people even finding you?" I asked. "You have a unique
            technology but your website is basic. I don't see any ads or
            influencers."
          </p>

          <p className="mb-5 text-base" data-id="element-5887">
            "Word spreads. Started in my town in Kentucky. Someone tells their
            sister in Ohio. She tells her friend in Connecticut. I don't
            advertise. I just make them and ship them to people who heard it
            actually works."
          </p>

          <p className="mb-5 text-base" data-id="element-5888">I asked him why he called it "Deep."</p>

          <p className="mb-3 text-base bg-yellow-100 p-3 border-l-4 border-yellow-400" data-id="element-5889">
            "Because that's what it does. It goes DEEP. Past the epidermis. Past
            the dermis. Into the fat layer where the drainage actually happens.
            Every other device stops at the surface. This one doesn't."
          </p>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5890">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5891"></span>
            The Email From Rob That Won My Heart
          </h2>

          <p className="mb-5 text-base" data-id="element-5892">
            After I shared my study results with Rob, he sent an email I didn't
            expect:
          </p>

          <div className="flex justify-center mb-8" data-id="element-5893">
            <img src="https://cdn.magicpatterns.com/uploads/fAZSSkMNzVAU5qsDtERS8v/pasted-image.png" alt="Email from Robert Hartley thanking Dr. Mitchell for the investigation and offering readers access to the belt at production cost" className="w-full max-w-2xl rounded border border-gray-300" data-id="element-5894" />
          </div>

          <p className="mb-5 text-base" data-id="element-5895">I called him immediately.</p>

          <p className="mb-5 text-base" data-id="element-5896">
            "Rob, you can't be serious about selling at production cost."
          </p>

          <p className="mb-5 text-base" data-id="element-5897">
            "Sarah, these manufacturers are selling people skin devices
            and promising fat loss. It doesn't work. People blame themselves
            when they should be blaming the engineering."
          </p>

          <p className="mb-3 text-base bg-yellow-100 p-3 border-l-4 border-yellow-400" data-id="element-5898">
            "If your investigation helps people find a device that actually
            reaches the fat layer AND saves them money? That's worth more to me
            than margin. Once they measure the results themselves, word spreads.
            That's the only marketing I need."
          </p>

          <div className="border-t border-b border-gray-300 py-8 my-12 bg-gray-50" data-id="element-5899">
            <h3 className="text-xl font-medium text-gray-800 mb-5 text-center border-b border-gray-300 pb-3" data-id="element-5900">
              READER ACCESS
            </h3>
            <h4 className="text-lg font-medium text-gray-800 mb-3 text-center" data-id="element-5901">
              Glokore Deep Red Light Therapy Wrap
            </h4>
            <CTAButtonRlt1 data-id="element-5902" />
            <div className="text-xs text-gray-500 mt-3 text-center" data-id="element-5903">
              Limited to current inventory of 340 units
            </div>
          </div>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5904">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5905"></span>
            Who This Is For
          </h2>

          <p className="mb-5 text-base" data-id="element-5906">
            Based on my investigation, this device produces the best results
            for:
          </p>

          <div className="space-y-3 mb-8 border border-gray-300 p-5 bg-gray-50 rounded" data-id="element-5907">
            <FeaturePointRlt2 data-id="element-5908">
              Women in perimenopause or menopause dealing with the hormonal
              redistribution that creates stubborn midsection fat—the "menopause
              belly" that appears even when diet and exercise stay consistent.
            </FeaturePointRlt2>
            <FeaturePointRlt2 data-id="element-5909">
              Anyone on GLP-1 medications (Ozempic, Wegovy, Mounjaro, Zepbound)
              who has lost significant weight but still has stubborn pockets
              that won't respond to the medication.
            </FeaturePointRlt2>
            <FeaturePointRlt2 data-id="element-5910">
              People already doing everything right who have that one area—lower
              belly, love handles, thighs—that won't change regardless of
              effort.
            </FeaturePointRlt2>
            <FeaturePointRlt2 data-id="element-5911">
              Post-pregnancy women dealing with stubborn abdominal fat that
              persists despite returning to pre-pregnancy weight.
            </FeaturePointRlt2>
            <FeaturePointRlt2 data-id="element-5912">
              Men with stubborn flank fat or lower belly that won't respond to
              caloric deficits or increased training.
            </FeaturePointRlt2>
            <FeaturePointRlt2 data-id="element-5913">
              Anyone who has tried red light therapy before and saw only skin
              benefits—your device probably couldn't reach the fat layer.
            </FeaturePointRlt2>
          </div>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5914">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5915"></span>
            Who This Is NOT For
          </h2>

          <div className="space-y-3 mb-8 border border-red-200 p-5 bg-red-50 rounded" data-id="element-5916">
            <p className="text-base" data-id="element-5917">
              This is not a weight loss solution. If you need to lose
              significant body weight, address that first through nutrition and
              activity. This targets stubborn deposits on people already at or
              near a healthy weight.
            </p>
            <p className="text-base" data-id="element-5918">
              If you won't move after treatments, this won't work. The light
              mobilizes fat—your activity burns it. Without movement, the
              released fat gets reabsorbed into nearby cells.
            </p>
            
          </div>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5919">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5920"></span>
            The Protocol That Worked
          </h2>

          <p className="mb-5 text-base" data-id="element-5921">For volunteers who saw results:</p>

          <div className="border border-gray-300 p-5 my-6 bg-gray-50 rounded" data-id="element-5922">
            <ul className="space-y-2 text-base" data-id="element-5923">
              <li data-id="element-5924">• 20 minutes per session, 5 days per week</li>
              <li data-id="element-5925">
                • Applied directly to stubborn area (wrap must contact skin)
              </li>
              <li data-id="element-5926">• Followed by 30 minutes of movement—walking is enough</li>
              <li data-id="element-5927">
                • 8+ glasses of water daily to support lymphatic clearance
              </li>
              <li data-id="element-5928">
                • Consistency for minimum 6 weeks before evaluating results
              </li>
            </ul>
          </div>

          <p className="mb-6 text-base" data-id="element-5929">
            Most volunteers noticed their clothes fitting differently before
            seeing obvious mirror changes. Measurements improved before visual
            changes became apparent. Trust the tape measure over the mirror.
          </p>

          <div className="border-t border-b border-gray-300 py-8 my-12 bg-gray-50" data-id="element-5930">
            <h3 className="text-xl font-medium text-gray-800 mb-5 text-center border-b border-gray-300 pb-3" data-id="element-5931">
              READER ACCESS
            </h3>
            <h4 className="text-lg font-medium text-gray-800 mb-3 text-center" data-id="element-5932">
              Glokore Deep Red Light Therapy Wrap
            </h4>
            <CTAButtonRlt1 data-id="element-5933" />
            <div className="text-xs text-gray-500 mt-3 text-center" data-id="element-5934">
              Limited to 340 units. Next production run ships in 6-8 weeks.
            </div>
          </div>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5935">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5936"></span>
            What the Volunteers Said
          </h2>

          <div className="my-8" data-id="element-5937">
            <TestimonialCardRlt2 name="Jennifer, 49" location="Perimenopausal" duration="2 months" testimonial="I've spent two years watching my waist thicken despite doing everything the same. Two months with this and I'm buying new jeans. Not because I lost weight—the scale barely moved. But whatever was sitting around my middle is finally letting go." data-id="element-5938" />
            <TestimonialCardRlt2 name="Maria, 54" location="On Mounjaro" duration="8 weeks" testimonial="Mounjaro changed my life for the big weight. But this lower belly was just... stuck. Like the medication couldn't see it. Eight weeks with the Deep wrap and I measured 1.9 inches gone. More progress than the previous four months of medication for this specific area." data-id="element-5939" />
            <TestimonialCardRlt2 name="David, 58" location="Cyclist" duration="10 weeks" testimonial="I've had these love handles since my 40s. Hundreds of miles on the bike every month. Caloric deficits that should have stripped them. Nothing worked. This thing finally did. My cycling jerseys fit the way they're supposed to now." data-id="element-5940" />
            <TestimonialCardRlt2 name="Linda, 61" location="Post-menopausal" duration="10 weeks" testimonial="I thought this body was just... what I had now. Menopause took what it wanted and I had to accept it. Turns out I didn't. Turns out the right tool actually works. I wish I'd found this three years ago." data-id="element-5941" />
            <TestimonialCardRlt2 name="Michael, 52" location="Former athlete" duration="12 weeks" testimonial="I tried two different red light belts before this. Both did nothing for fat—my skin looked better, sure, but the belly stayed. I assumed I was a non-responder. Now I realize I just had devices that couldn't actually reach the fat. This one does. The results prove it." data-id="element-5942" />
            <TestimonialCardRlt2 name="Rachel, 38" location="Postpartum" duration="10 weeks" testimonial="Eighteen months of hating my body every time I looked in the mirror. Eighteen months of my husband telling me I looked fine when I knew I didn't feel fine. This pouch was a daily reminder of what pregnancy took from me. Now it's actually going away. I feel like myself again." data-id="element-5943" />
          </div>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5944">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5945"></span>
            My Professional Assessment
          </h2>

          <p className="mb-5 text-base" data-id="element-5946">
            After 12 weeks of controlled testing, here's what I can confidently
            state:
          </p>

          <div className="space-y-3 mb-8 border border-yellow-400 p-5 bg-yellow-50 rounded" data-id="element-5947">
            <p className="text-base" data-id="element-5948">
              <strong data-id="element-5949">1. The mechanism is real.</strong> Red light at 660nm
              wavelength can trigger transitory pore formation in adipocytes,
              releasing stored lipids. This is documented physics, not
              marketing.
            </p>
            <p className="text-base" data-id="element-5950">
              <strong data-id="element-5951">2. Most consumer devices can't deliver it.</strong> They
              were designed for skin benefits and later marketed for fat loss
              without engineering changes. The light scatters before reaching
              the fat layer in therapeutic concentration.
            </p>
            <p className="text-base" data-id="element-5952">
              <strong data-id="element-5953">3. Reflector-based delivery changes everything.</strong>{' '}
              The Glokore device's focused beam delivery produced 3-4x the
              results of standard designs with identical specifications.
            </p>
            <p className="text-base" data-id="element-5954">
              <strong data-id="element-5955">4. The results are sustained.</strong> Unlike the other
              devices that plateaued by week 4, the Glokore volunteers continued
              improving through week 12. The treatment is cumulative when the
              light actually reaches the target tissue.
            </p>
            <p className="text-base" data-id="element-5956">
              <strong data-id="element-5957">5. This isn't magic.</strong> You still need to move after
              treatment. You still need to stay hydrated. The device mobilizes
              fat; your body has to clear and burn it. But for people already
              doing those things, this removes the bottleneck.
            </p>
          </div>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5958">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5959"></span>
            The Measurement Guarantee
          </h2>

          <p className="mb-5 text-base" data-id="element-5960">
            Rob insists on this: measure yourself before you start. Measure
            weekly. Track your results.
          </p>

          <p className="mb-6 text-base" data-id="element-5961">
            If your stubborn area isn't shrinking within 60 days of consistent
            use following the protocol, send it back. Full refund. He doesn't
            want your money if it doesn't work for you.
          </p>

          <p className="mb-6 text-base" data-id="element-5962">
            That's the confidence that comes from actual engineering, not
            marketing promises.
          </p>

          <div className="border-t border-b border-gray-300 py-8 my-12 bg-gray-50" data-id="element-5963">
            <h3 className="text-xl font-medium text-gray-800 mb-5 text-center border-b border-gray-300 pb-3" data-id="element-5964">
              READER ACCESS
            </h3>
            <h4 className="text-lg font-medium text-gray-800 mb-3 text-center" data-id="element-5965">
              Glokore Deep Red Light Therapy Wrap
            </h4>
            <CTAButtonRlt1 data-id="element-5966" />
            <div className="text-xs text-gray-500 mt-3 text-center" data-id="element-5967">
              Limited to 340 units from current production run.
            </div>
          </div>

          <div className="border-t border-gray-200 mt-12 pt-6" data-id="element-5968">
            <div className="flex items-center mb-4" data-id="element-5969">
              <div className="w-8 h-8 overflow-hidden rounded-full flex-shrink-0 mr-2 border border-gray-300" data-id="element-5970">
                <img src="https://cdn.magicpatterns.com/uploads/2GyeX4XySat8iU7eJrVRv7/Nv5hjWTSn23lO9R9rbGUj.png" alt="Dr. Sarah Mitchell" className="w-full h-full object-cover" data-id="element-5971" />
              </div>
              <p className="text-sm text-gray-800" data-id="element-5972">
                <span className="font-medium" data-id="element-5973">
                  Dr. Sarah Mitchell, PhD | Exercise Physiology | University of
                  Texas [Verified]
                </span>
              </p>
            </div>
            <p className="text-sm text-gray-700 mb-3 bg-yellow-100 p-2 border-l-2 border-yellow-500" data-id="element-5974">
              <strong data-id="element-5975">P.S.</strong> — If you've tried red light therapy before
              and only got skin benefits, you weren't scammed. The science is
              real. Those devices work for what they were designed for. They
              just can't reach the fat layer.
            </p>
            <p className="text-sm text-gray-700 mb-3 bg-yellow-100 p-2 border-l-2 border-yellow-500" data-id="element-5976">
              The Deep wrap exists because an engineer who spent 32 years making
              light penetrate the ocean floor asked one question: "Why isn't
              this reaching my wife's fat cells?"
            </p>
            <p className="text-sm text-gray-700 mb-3 bg-yellow-100 p-2 border-l-2 border-yellow-500" data-id="element-5977">
              Then he fixed it.
            </p>
            <p className="text-sm text-gray-700 bg-yellow-100 p-2 border-l-2 border-yellow-500" data-id="element-5978">
              <strong data-id="element-5979">P.P.S.</strong> — Rob personally answers technical
              questions. His email is on the product page. When's the last time
              you could reach the actual engineer who built something—not
              customer service, not a chatbot, the engineer—and get a real
              answer?
            </p>
          </div>
        </div>
      </main>
      <div className="px-4 sm:px-8 py-6 border-t border-gray-200 bg-gray-50" data-id="element-5980">
        <div className="max-w-4xl mx-auto text-[10px] text-gray-400 leading-tight" data-id="element-5981">
          <p className="mb-2 font-medium" data-id="element-5982">Important Disclaimer</p>
          <p className="mb-2" data-id="element-5983">
            The Glokore Deep Red Light Therapy Wrap mobilizes fat from targeted
            areas. It does not destroy fat cells or replace diet and exercise.
          </p>
          <p className="mb-2" data-id="element-5984">
            The released fat must be cleared by your lymphatic system (requires
            movement) and oxidized by your metabolism (requires caloric demand).
            If you use the wrap and remain sedentary, mobilized fat will be
            reabsorbed.
          </p>
          <p className="mb-2" data-id="element-5985">
            This technology works WITH your body's natural processes, not
            instead of them.
          </p>
          <p className="mb-2" data-id="element-5986">
            Continue your exercise routine. Continue eating well. Use this to
            finally see results in the areas that have never responded.
          </p>
          <p data-id="element-5987">
            Results vary based on individual physiology, consistency of use, and
            activity levels.
          </p>
        </div>
      </div>
      <div className="bg-black h-3 w-full" data-id="element-5988"></div>
    </div>;
};
export default AdvertorialRlt2;